export enum HomeItemType {
  Tour = 'TourDto[]',
  User = 'UserDto[]',
  Journey = 'JourneyDto[]',
  Prime = 'PrimeDto[]',
  Immigration = 'ImmigrationGuideDtoDto[]',
  Post = 'PostDto[]',
}
